import { useApiRequestHelper } from '@/composables/useApiRequestHelper.js'
import { useAuthStore } from '@/stores/authenticated/AuthStore.js'

export const authenticatedMiddleware = async (to, from) => {
  const authStore = useAuthStore()
  const { setApiUrlAuthenticated } = useApiRequestHelper()

  if (!authStore.isAuthenticated) {
    return { name: 'index' }
  }

  await setApiUrlAuthenticated()
}
